import { validateToken } from '../utils';
import {
    login,
    logout,
    register,
    fetchUser,
    fetchUserAuthors,
    lockUserCurrency,
    refreshToken
} from '../api';

const state = {
    token: '',
    expiry: null,
    user: {},
    userAuthors: []
};

const getters = {
    loggedIn(state) {
        return !!(state.token.length && state.user.pk);
    },
    userGroups: state => {
        if (!state.user.groups) return [];

        return state.user.groups;
    },
    userFullName: state => {
        if (!state.user.first_name) return '';

        return `${state.user.last_name} ${state.user.first_name} ${state.user.patronymic}`;
    },
    isInGroup: state => group => {
        if (!state.user.groups || !state.user.groups.length) return false;

        return state.user.groups.includes(group);
    },
    isAdmin: (_, getters) => {
        return getters.isInGroup('administrators');
    },
    isStaff: (_, getters) => {
        return getters.isInGroup('staff');
    },
    isListener: (_, getters) => {
        return getters.isInGroup('listeners');
    },
    isPartner: (_, getters) => {
        return getters.isInGroup('partners');
    },
    isManager: (_, getters) => {
        return getters.isInGroup('manager');
    },
    personalDataFilled: state => {
        return !!(
            state.user.first_name &&
            state.user.last_name &&
            state.user.birth_day &&
            state.user.phone
        );
    },
    userCurrency: state => {
        if (!state.user.currency) return null;

        return state.user.currency;
    },
    isGuestAccess(_, __, rootState) {
        return Boolean(rootState.guestAccess);
    }
};

const mutations = {
    SET_TOKEN(state, { token, expiry = 0 }) {
        //
        state.token = token;
        state.expiry = expiry;
        localStorage.setItem('token', token);
        localStorage.setItem('expiry', expiry);
    },
    SET_USER(state, user) {
        state.user = user;
    },
    CLEAR_USER_DATA(state) {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        state.user = {};
        state.token = '';
        state.userAuthors = [];
    },
    SET_USER_AUTHORS(state, authors) {
        state.userAuthors = authors;
    },
    SET_USER_CURRENCY(state, currency) {
        state.user.currency = currency;
    },
    LOCK_USER_CURRENCY(state) {
        state.user.blocked_currency = true;
    },
    // util

    INVALID_TOKEN() {},
    REFRESH_TOKEN_ERROR() {}
};

const actions = {
    signIn({ commit }, { username, password }) {
        return login(username, password).then(response => {
            if (response.token) {
                commit('SET_TOKEN', validateToken(response.token));
            }
            if (response.user) {
                localStorage.setItem('user', JSON.stringify(response.user));
                commit('SET_USER', response.user);
            }
        });
    },
    refreshToken({ commit }, token) {
        return refreshToken(token).then(response => {
            commit('SET_TOKEN', validateToken(response.token) || '');
        });
    },
    join(_, payload) {
        return register(payload).then(response => {
            console.log(response);
        });
    },
    logout({ commit }) {
        return logout()
            .then(() => {
                commit('CLEAR_USER_DATA');
            })
            .catch(error => {
                console.log(error);
            });
    },
    async fetchUser({ commit, dispatch }) {
        let localUser = localStorage.getItem('user');
        let localToken = localStorage.getItem('token');
        if (localUser) {
            commit('SET_USER', JSON.parse(localUser));
        }

        const validatedToken = validateToken(localToken);

        if (!validatedToken) {
            commit('INVALID_TOKEN');
            return;
        }

        commit('SET_TOKEN', validatedToken);

        const response = await fetchUser();

        if (response) {
            commit('SET_USER', response);
        }
    },
    // @TODO MOVE THIS TO BOOK ?
    fetchUserAuthors({ commit }) {
        return fetchUserAuthors().then(({ results }) => {
            commit('SET_USER_AUTHORS', results);
        });
    },
    async lockUserCurrency({ commit }, currency) {
        await lockUserCurrency(currency);
        commit('SET_USER_CURRENCY', currency);
        commit('LOCK_USER_CURRENCY');
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
